"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const ConnectorUnknown = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 20 20", testID: "connectorIcon-unknown" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement(react_native_svg_1.Path, { d: "M-6-6h32v32H-6z" }),
            react_1.default.createElement(react_native_svg_1.G, { strokeLinecap: "square", transform: "translate(1 1)" },
                react_1.default.createElement(react_native_svg_1.Path, { d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18ZM7.145 4.074c1.675-.741 3.847-.654 4.588.546.741 1.2.23 2.594-1.041 3.67C9.422 9.368 9 9.954 9 10.8", stroke: color }),
                react_1.default.createElement(react_native_svg_1.Circle, { fill: color, cx: 9, cy: 14.1, r: 1 })))));
};
ConnectorUnknown.defaultProps = {
    color: 'currentColor',
    width: 30,
    height: 30,
};
exports.default = react_1.default.memo(ConnectorUnknown);
